import axios from "axios"; 

const LocationBasedService = {
  // Fetch all purchase orders
  async getAll(date) {
    try {
      const response = await axios.get(`/LocationBasedCount/GetEmpLocationCount?p_date=${date}`, {
      //  const response = await axios.get(`/LocationBasedCount/GetEmpLocationCount?p_date=${date}`, {
        // headers: {
          
        // },
      });

      console.log("API response:", response.data);
      return Array.isArray(response.data.ResultSet) ? response.data.ResultSet : [];
    } catch (error) {
      console.error("Error fetching locations:", error);
      throw error;
    }
  },

    async getEmpByLocation(date, location) {
    try {
      const response = await axios.get(`/LocationBasedCount/GetEmployeesByLocation?p_date=${date}&location=${location}`, {
      //  const response = await axios.get(`/LocationBasedCount/GetEmpLocationCount?p_date=${date}`, {
        // headers: {
          
        // },
      });

      console.log("API response:", response.data);
      return Array.isArray(response.data.ResultSet) ? response.data.ResultSet : [];
    } catch (error) {
      console.error("Error fetching locations:", error);
      throw error;
    }
  },
}

export default LocationBasedService;
